import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/map";

const informationMap = {
  create(param) {
    return http.spin.payload(`${BASE}/create`, param);
  },
  update(param) {
    return http.spin.payload(`${BASE}/update`, param);
  },
  deleteRecordById(param) {
    return http.confirm.tip.post(`${BASE}/deleteRecordById`, param);
  },
};

export default informationMap;
